module.exports = __webpack_public_path__ + "media/smart_glass.77f5fa95.webm";